var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Loader } from '../loader';
import { Text } from '../text';
import { loaderStyle, loaderWrapperStyle } from './styles';
function ButtonLoader(_a) {
    var isIconOnly = _a.isIconOnly, size = _a.size, themedStyle = _a.themedStyle;
    return (_jsxs("span", __assign({ css: loaderWrapperStyle({ hasLoadingLabel: !isIconOnly, size: size }) }, { children: [_jsx(Loader, { "aria-label": "Loading", css: loaderStyle({ themedStyle: themedStyle }), width: size === 'small' ? '12' : '16' }), !isIconOnly && _jsx(Text, __assign({ "aria-hidden": "true" }, { children: "Loading\u2026" }))] })));
}
export default ButtonLoader;
